const styles = ({ color, misc }) => ({
  dashboard: {
    background: `${color.uiBackground} 0% 0% no-repeat padding-box`,
    margin: `-${misc.headerHeight}px 38px 0 38px`,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Dashboard/Main/styles.js